import two from '@/json/two'
import chapter from '@/json/chapter'
import hsnUrls from '@/json/hsnUrls'
import modalCategories from '@/json/modalCategories'
import api from '@/api'

const state = {
  twos: two,
  chapter: chapter,
  apiPublicToken: null,
  initalModalShown: false,
  hsnUrls,
  modalCategories
}

const mutations = {
  SET_API_PUBLIC_TOKEN(state, apiToken) {
    state.apiPublicToken = apiToken
  },
  SET_INITIAL_MODAL_SHOWN(state, value) {
    state.initalModalShown = value
  }
}

const actions = {
  async getPublicApiToken({ commit }) {
    const token = await api.getPublicApiToken()
    commit('SET_API_PUBLIC_TOKEN', token)
  },
  initialModalShown({ commit }) {
    commit('SET_INITIAL_MODAL_SHOWN', true)
  }
}

const getters = {
  twos: (state) => state.twos,
  chapter: (state) => state.chapter,
  apiPublicToken: (state) => state.apiPublicToken,
  initalModalShown: (state) => state.initalModalShown,
  hsnUrls: (state) => state.hsnUrls,
  modalCategories: (state) => state.modalCategories
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
